import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { Observable } from "rxjs";
import { TransferenciaConta } from "../api/dto/transferencia-conta";

@Injectable({
    providedIn: 'root'
})
export class TrasnferenciaContaService{

    constructor(private http: HttpClient) {}

    private url: string = UrlServidor.URL_BASE + 'transferencias/';


    listarTrasnferenciasSaidaConciliacao( contaId?: number): Observable<TransferenciaConta[]> {
        return this.http.get<TransferenciaConta[]>(this.url + 'conta/' + contaId + '/saidas' );
    }

    listarTrasnferenciasEntradaConciliacao(contaId?: number): Observable<TransferenciaConta[]> {
        return this.http.get<TransferenciaConta[]>(this.url + 'conta/' + contaId + '/entradas/');
    }

    listarSangriasCaixa(empresaId?: number, data?: Date): Observable<TransferenciaConta[]> {
        return this.http.get<TransferenciaConta[]>(this.url + 'empresa/' + empresaId + '/data/' + data);
    }

    transferir(transferencia?: TransferenciaConta): Observable<TransferenciaConta> {
        return this.http.post<TransferenciaConta>(this.url, transferencia);
    }

    transferirSangria(transferencia?: TransferenciaConta): Observable<TransferenciaConta> {
        return this.http.post<TransferenciaConta>(this.url + 'sangria-caixa', transferencia);
    }

    excluir(id?: number): Observable<void> {
        return this.http.delete<void>(this.url + id);
    }
}